import {cloneDeep} from 'lodash';
import {createImageObject} from '../utils';
import {
    placeHolder,
    designFormConfig,
    intelFormConfig,
    defaultIntelFormData,
    defaultDesignFormData,
    btbIndustryNumList,
    openIndustryByHot
} from '@/views/V2/image/template/utils';
import {industryOptionsByNum, designSizeOptions} from '../../views/V2/image/template/utils/constants';

function getConfigAndData(modelType) {
    if (modelType === 'intelForm') {
        return {
            configKey: 'intelFormConfig',
            configValue: cloneDeep(intelFormConfig),
            dataKey: 'intelFormData',
            dataValue: cloneDeep(defaultIntelFormData)
        };
    }
    return {
        configKey: 'designFormConfig',
        configValue: cloneDeep(designFormConfig),
        dataKey: 'designFormData',
        dataValue: cloneDeep(defaultDesignFormData)
    };
}

function getTemplateMap() {
    // 添加模板行业映射
    let templateIndustryObj = {};
    industryOptionsByNum.concat({
        value: 'culture',
        label: '文创团队'
    }).map(item => {
        templateIndustryObj[item.label] = item.value;
    });

    let templateRatioObj = {};
    designSizeOptions.map(item => {
        templateRatioObj[item.label] = item.value;
    });

    return {templateIndustryObj, templateRatioObj};
}

export default {
    namespaced: true,
    state: {
        displayImg: [],
        previewType: 'tile',
        placeHolder,
        industryList: [],
        designFormConfig: cloneDeep(designFormConfig),
        intelFormConfig: cloneDeep(intelFormConfig),
        intelFormData: cloneDeep(defaultIntelFormData),
        designFormData: cloneDeep(defaultDesignFormData),
        toolBarLoading: false,
        intelFormExt: {},
        canSubmit: false,
        modelType: 'intelForm',
        pageLoadingStatus: {
            show: false,
            title: ''
        },
        targetCount: 0,
        useWaterFall: false,
        filterOptions: {
            background: {},
            mainPart: {}
        }
    },
    mutations: {
        UPDATE_COMMON_STATE(state, {key, value}) {
            state[key] = value;
        },
        UPDATE_MULTIPLE_STATES(state, updates) {
            for (let item of updates) {
                state[item.key] = item.value;
            }
        },
        UPDATE_FORM_DATA(state, {form, key, value}) {
            state[form] = {...state[form], [key]: value};
        }
    },
    actions: {
        updateFormData({commit}, data) {
            const {form, key, value} = data;
            commit('UPDATE_FORM_DATA', {
                form,
                key,
                value
            });
        },
        updateCommonState({commit}, {key, value}) {
            commit('UPDATE_COMMON_STATE', {
                key,
                value
            });
        },
        updateMultipleState({commit}, data) {
            commit('UPDATE_MULTIPLE_STATES', data);
        },
        handleDesignFormSubmit({commit, state}, {data}) {
            const displayImg = [];
            const length = Math.min(state.displayImg.length, data.length);
            for (let i = 0; i < length; i++) {
                const {taskId, templateId, recordId, editorParams, ext} = data[i];
                displayImg.push({
                    ...state.displayImg[i],
                    taskId,
                    templateId,
                    recordId,
                    editorParams,
                    unFinished: false,
                    ext: ext ? JSON.parse(ext) : {}
                });
            }
            commit('UPDATE_MULTIPLE_STATES', [
                // 更新展示区图片
                {
                    key: 'displayImg',
                    value: displayImg
                }
            ]);
        },
        /**
         * 处理设计表单提交临时数据，用于处理图片替换，每返回一张图片后，替换结果区第一张url为空的图片
         */
        handleDesignFormSubmitTemp({commit, state}, {data}) {
            const displayImg = [];
            let alreadyReplaced = false; // 用于表示本次提交是否已经替换图片，只替换一次
            for (const curImg of state.displayImg) {
                // 若图片url不为空，或本次提交已替换，则添加displayImg的结果到展示区
                if (curImg.url || alreadyReplaced) {
                    displayImg.push({
                        ...curImg,
                        unFinished: true
                    });
                }
                else {
                    // 若本次提交未替换，则添加本次提交结果展示区
                    displayImg.push({
                        ...createImageObject(data),
                        unFinished: true
                    });
                    alreadyReplaced = true;
                }
            }
            commit('UPDATE_MULTIPLE_STATES', [
                // 更新展示区图片
                {
                    key: 'displayImg',
                    value: displayImg
                }
            ]);
        },
        /**
         * 处理设计表单提交超时
         * @param {Number} data 本次提交的展示区图片数量，用于截取展示区图片
         */
        handleDesignFormSubmitTimeout({commit, state}, {data}) {
            const displayImg = state.displayImg.slice(0, data);
            commit('UPDATE_MULTIPLE_STATES', [
                // 更新展示区图片
                {
                    key: 'displayImg',
                    value: displayImg
                }
            ]);
        },
        changeLoadingStatus({commit}, {targetCount, ratioNum = 1}) {
            // loading态，且有骨架屏数量，则生成骨架屏的结果区占位数据
            if (typeof targetCount === 'number') {
                const baseDisplayImg = Array.from({
                    length: targetCount
                }, (_, i) => createImageObject({
                    ratioNum: ratioNum,
                    recordId: i
                }));
                commit('UPDATE_COMMON_STATE', {
                    key: 'displayImg',
                    value: baseDisplayImg
                });
            }
        },
        // 获取图片常量数据，行业选项需要用到
        async getImageTplConstants({commit, state}, model) {
            try {
                const resData = await model.imageCreate.getImageTplConstants({productLine: 'QINGDUO'});
                const allIndustryList = resData?.industry?.map(item => {
                    return {
                        value: `${item.index > 1 ? item.index : ''}`,
                        label: item.label === '全部' ? '全部行业' : item.label
                    };
                });
                const industryList = openIndustryByHot.map(label => {
                    return allIndustryList.find(item => item.label === label);
                }).filter(item => item !== undefined);
                const industryOptions = state.intelFormConfig.find(item =>
                    item.name === 'template'
                )?.params?.industryOptions;
                const industryListWithTag = (Array.isArray(industryOptions) && industryOptions.length)
                    ? industryList.map(item => {
                        const industry = industryOptions.find(option => item.label === option.label)?.industry;
                        return {
                            ...item,
                            industry: industry || ''
                        };
                    }) : industryList;
                let intelFormConfig = state.intelFormConfig;
                let industryIndex = intelFormConfig.findIndex(item => item.name === 'template');
                intelFormConfig[industryIndex].params.industryOptions = industryListWithTag;

                commit('UPDATE_MULTIPLE_STATES', [
                    {
                        key: 'intelFormConfig',
                        value: intelFormConfig
                    },
                    {
                        key: 'industryList',
                        value: industryList
                    }
                ]);
            }
            catch (err) {
                throw err;
            }
        },

        // 获取背景图/主体选项配置信息
        async initImageConstants({commit, state}, {model, domain}) {
            try {
                const resData = await model.imageCreate.getImageConstant({domain});
                let intelFormConfig = state.intelFormConfig;
                let designFormConfig = state.designFormConfig;
                let {templateIndustryObj, templateRatioObj} = getTemplateMap();

                if (domain === 1) { // 获取背景选项
                    const intelFormParams = intelFormConfig.find(item =>
                        item.name === 'background'
                    )?.params;
                    const designFormParams = designFormConfig.find(item =>
                        item.name === 'background'
                    )?.params;

                    resData.industry.map(item => {
                        item.templateValue = templateIndustryObj[item.label];
                    });

                    resData.ratio.map(item => {
                        item.templateValue = templateRatioObj[item.label];
                    });

                    let bgOptions = {
                        industryOptions: resData.industry,
                        ratioOptions: resData.ratio,
                        styleOptions: resData.style,
                        colorOptions: resData.color
                    };

                    Object.assign(intelFormParams, bgOptions);
                    Object.assign(designFormParams, bgOptions);

                    commit('UPDATE_MULTIPLE_STATES', [
                        {
                            key: 'intelFormConfig',
                            value: intelFormConfig
                        },
                        {
                            key: 'designFormConfig',
                            value: designFormConfig
                        },
                        {
                            key: 'filterOptions',
                            value: {
                                ...state.filterOptions,
                                background: bgOptions
                            }
                        }
                    ]);
                }
                if (domain === 2) { // 获取主题选项
                    const designFormParams = designFormConfig.find(item =>
                        item.name === 'mainPart'
                    )?.params;

                    resData.industry.map(item => {
                        item.templateValue = templateIndustryObj[item.label];
                    });

                    let mainPartOptions = {
                        industryOptions: resData.industry,
                        styleOptions: resData.style,
                        subjectTypeOptions: resData.subjectType
                    };
                    Object.assign(designFormParams, mainPartOptions);
                    commit('UPDATE_MULTIPLE_STATES', [
                        {
                            key: 'designFormConfig',
                            value: designFormConfig
                        },
                        {
                            key: 'filterOptions',
                            value: {
                                ...state.filterOptions,
                                mainPart: mainPartOptions
                            }
                        }
                    ]);
                }
            }
            catch (err) {
                throw err;
            }
        },
        resetFromData({commit, state}) {
            const modelType = state.modelType;
            const {configKey, configValue, dataKey, dataValue} = getConfigAndData(modelType);
            const nowFormData = state[modelType === 'intelForm' ? 'intelFormData' : 'designFormData'];
            dataValue.template.titleType = nowFormData.template.titleType;

            // 重置表单配置时保留筛选项配置
            configValue.map(item => {
                if (item.name === 'background') {
                    item.params = {
                        ...item.params,
                        ...state.filterOptions.background
                    };
                }
                if (item.name === 'mainPart') {
                    item.params = {
                        ...item.params,
                        ...state.filterOptions.mainPart
                    };
                }
            });
            commit('UPDATE_MULTIPLE_STATES', [
                {
                    key: configKey,
                    value: configValue
                },
                {
                    key: dataKey,
                    value: dataValue
                },
                {
                    key: 'canSubmit',
                    value: false
                }
            ]);
        }
    },
    getters: {
        formExt: state => {
            // 提取行业比例信息，用于联动
            const {intelFormData, designFormData, modelType} = state;
            const intelTemp = intelFormData.template;
            const designTemp = designFormData.template;

            const intelTempType = intelTemp.type;
            const designTempType = designTemp.type;
            const intelIndustry = intelTemp[intelTempType].industry.value;
            const designIndustry = designTemp[designTempType].industry.value;
            const intelRatio = intelTemp[intelTempType].sizeControl.value.ratio;
            const designRatio = designTemp[designTempType].sizeControl.value.ratio;

            const industry = modelType === 'intelForm' ? intelIndustry : designIndustry;
            const activeIsBusiness = btbIndustryNumList.includes(+industry);
            const industryOptions = state.intelFormConfig.find(item =>
                item.name === 'template'
            )?.params?.industryOptions;
            let industryTag;
            if (Array.isArray(industryOptions) && industryOptions.length) {
                industryTag = industryOptions.find(item => item.value === industry)?.industry;
            }

            return {
                designFormIndustry: designIndustry,
                intelFormIndustry: intelIndustry,
                designFormRadio: designRatio,
                intelFormRadio: intelRatio,
                activeIsBusiness,
                industryList: state.industryList,
                industry,
                industryTag
            };
        }
    }
};